var _rect, _rect2, _circle, _circle2, _circle3, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path, _circle4, _path2, _path3, _path4, _circle5, _circle6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolio({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 80,
    width: 240,
    height: 240,
    rx: 8,
    stroke: "white",
    strokeWidth: 4,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 80,
    width: 240,
    height: 40,
    rx: 8,
    stroke: "white",
    strokeWidth: 4,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 100,
    r: 6,
    fill: "#EF4444"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 100,
    r: 6,
    fill: "#22C55E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 100,
    r: 6,
    fill: "#3B82F6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 140,
    width: 60,
    height: 8,
    rx: 4,
    fill: "white",
    opacity: 0.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 140,
    width: 40,
    height: 8,
    rx: 4,
    fill: "white",
    opacity: 0.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 140,
    width: 50,
    height: 8,
    rx: 4,
    fill: "white",
    opacity: 0.7
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 180,
    width: 120,
    height: 12,
    rx: 2,
    fill: "white",
    opacity: 0.9
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 200,
    width: 200,
    height: 8,
    rx: 2,
    fill: "white",
    opacity: 0.6
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 215,
    width: 180,
    height: 8,
    rx: 2,
    fill: "white",
    opacity: 0.6
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 250,
    width: 60,
    height: 50,
    rx: 4,
    stroke: "white",
    strokeWidth: 2,
    fill: "none"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 250,
    width: 60,
    height: 50,
    rx: 4,
    stroke: "white",
    strokeWidth: 2,
    fill: "none"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 250,
    width: 60,
    height: 50,
    rx: 4,
    stroke: "white",
    strokeWidth: 2,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 265 L140 285 L120 305",
    stroke: "#3B82F6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 275,
    r: 15,
    stroke: "#EF4444",
    strokeWidth: 3,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250 270 L290 270",
    stroke: "#22C55E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M250 280 L290 280",
    stroke: "#22C55E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M250 290 L290 290",
    stroke: "#22C55E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 100,
    r: 4,
    fill: "#3B82F6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 300,
    r: 4,
    fill: "#EF4444"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 300,
    r: 4,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.f2d6ae57f1ba1ec543dfe0ba0447a511.svg";
export { ForwardRef as ReactComponent };